var map = {
	"./57_legs.mp3": "bc9f3",
	"./58_hands.mp3": "fda5",
	"./59_head.mp3": "b69d",
	"./61_stretch.mp3": "bfe6",
	"./62_shake.mp3": "c389",
	"./63_pat.mp3": "cfa9",
	"./M_Brilliant.mp3": "9e21",
	"./M_Excellent.mp3": "a30a",
	"./M_Fantastic.mp3": "84d4",
	"./M_Great.mp3": "a420",
	"./M_Perfect.mp3": "4c59",
	"./M_Think again.mp3": "3e44",
	"./M_Try again.mp3": "5d19",
	"./M_Very good.mp3": "bec0",
	"./M_Well done.mp3": "339f",
	"./M_Work harder.mp3": "b867",
	"./click.mp3": "46bc",
	"./false.mp3": "956f",
	"./true.mp3": "47ae8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c00e";